import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DbExportGlyph = /*#__PURE__*/createElement("g", {
  id: "db-export-icon"
}, /*#__PURE__*/createElement("path", {
  d: "M48.36 19.24l-5.22-5.22c-.21-.21-.47-.32-.73-.38-.08-.02-.16-.04-.24-.05-.04 0-.08-.01-.12-.01-.02 0-.04-.01-.05-.01-.56 0-1.04.31-1.3.76l-5.08 5.08a1.49 1.49 0 000 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l2.75-2.75v13.56c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V18.62l2.74 2.74c.59.59 1.54.59 2.12 0s.6-1.53.01-2.12z"
}), /*#__PURE__*/createElement("path", {
  d: "M65.49 32.03c-.14-2.82-3.22-4.96-7.72-6.38-.96-.3-1.93.43-1.93 1.44 0 .65.42 1.23 1.04 1.43 3.6 1.13 5.62 2.56 5.62 3.72 0 2.31-7.99 5.67-20.5 5.67s-20.5-3.36-20.5-5.67c0-1.16 2.03-2.59 5.63-3.72.62-.19 1.04-.78 1.04-1.43 0-1.01-.97-1.74-1.93-1.44-4.5 1.42-7.58 3.56-7.72 6.38h-.02v29.72c0 5.69 11.82 8.67 23.5 8.67s23.5-2.98 23.5-8.67V32.03h-.01zM62.5 61.74c0 2.31-7.99 5.67-20.5 5.67s-20.5-3.36-20.5-5.67v-5.37c4.25 2.77 12.41 4.2 20.5 4.2s16.25-1.43 20.5-4.2v5.37zm0-9.83c0 2.31-7.99 5.67-20.5 5.67s-20.5-3.36-20.5-5.67v-5.37c4.25 2.77 12.41 4.2 20.5 4.2s16.25-1.43 20.5-4.2v5.37zm0-9.84c0 2.31-7.99 5.67-20.5 5.67s-20.5-3.36-20.5-5.67V36.7c4.25 2.77 12.41 4.2 20.5 4.2s16.25-1.43 20.5-4.2v5.37z"
}));
const DbExport = createSvg({
  name: 'db-export',
  path: DbExportGlyph
});

export default DbExport;
export { DbExportGlyph };
